import React, { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import DataTable from '../../../sharedModules/dataTable';

import { CertificateSubmission } from '../../model';

import axios from '../../../sharedModules/utils/axios.utils';

const RecentSubmissionsPage: FC = () => {
  const history = useHistory();
  let [certificateSubmissions, setCertificateSubmissions] = useState<CertificateSubmission[]>([]);
  let [loading, setLoading] = useState(true);

  const fetchCertificateSubmissions = async () => {
    try {
      let response: any = await axios.get('energy_solutions/certificate_submissions');
      setCertificateSubmissions(response.data.result || []);
    } catch (error) {
      console.error('Error fetching submissions:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = (row: any) => {
    history.push(`/energy_solutions/submissions/${row.id}`);
  };

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  const submissionColumns = [
    {
      name: 'Project Name',
      selector: 'submission_name',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Created Date',
      selector: 'created_at',
      sortable: true,
      cell: (row) => formatDate(row.created_at),
      grow: 1,
    },
    {
      name: 'Certificates',
      cell: (row) => (
        <Chip
          label={`${row.ahri_certificates?.length || 0} certificates`}
          size="small"
          color={row.ahri_certificates?.length > 0 ? 'primary' : 'default'}
        />
      ),
      grow: 0.8,
    },
  ];

  useEffect(() => {
    fetchCertificateSubmissions();
  }, []);

  return (
    <Grid container rowSpacing={2}>
      <Grid item xs={12}>
        <PageHeader mainTitle="Energy Solutions" subTitle="Previous Submissions" />
      </Grid>
      <Grid item xs={12}>
        <Box>
          <Typography variant="h6" gutterBottom>
            Recent Submissions
          </Typography>

          {loading ? (
            <Typography>Loading submissions...</Typography>
          ) : (
            <DataTable
              title=""
              columns={submissionColumns}
              data={certificateSubmissions}
              onRowClicked={handleRowClick}
              striped
              dense
              highlightOnHover
              pointerOnHover
              pagination
              paginationPerPage={10}
              noHeader
              noDataComponent={
                <Box p={3} textAlign="center">
                  <Typography variant="body2" color="textSecondary">
                    No submissions found.
                  </Typography>
                </Box>
              }
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default RecentSubmissionsPage;
